/**
 * Date and Time utilities for Reva Jewellers.
 * Ensures consistent handling of UTC timestamps from the backend API/database
 * and formats them accurately in the local Indian timezone (IST / en-IN).
 */

export const parseUtcDate = (dateVal) => {
  if (!dateVal) return null;
  if (dateVal instanceof Date) return dateVal;
  let str = String(dateVal).trim();
  if (str.includes(" ") && !str.includes("T")) {
    str = str.replace(" ", "T");
  }
  // If no timezone suffix (Z or offset like +05:30), append Z since backend stores UTC
  if (!str.endsWith("Z") && !/[+-]\d{2}:?\d{2}$/.test(str)) {
    str += "Z";
  }
  const d = new Date(str);
  return isNaN(d.getTime()) ? new Date(dateVal) : d;
};

export const formatDateTime = (dateVal, options = {}) => {
  if (!dateVal) return "—";
  const d = parseUtcDate(dateVal);
  if (!d || isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  });
};

export const formatDate = (dateVal) => {
  if (!dateVal) return "—";
  const d = parseUtcDate(dateVal);
  if (!d || isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

